<template>
    <div class="search-list">
        <div class="top">
            <input type="text" v-model="value" placeholder="请输入查询服务">
            <div @click="search" class="sear">查询</div>
        </div>
        <van-tabs v-model="active" @click="getSearchListInfo">
            <van-tab v-for="(item, index) in tabNameList" :key="index" :title="item.text"></van-tab>
        </van-tabs>
        <van-list :error.sync="error" error-text="请求失败，点击重新加载">
            <div class="tab-p" v-for="(itme,idnex) of ListData" :key="idnex">
                <p v-html="test(itme)"></p>
                <span>></span>
            </div>
        </van-list>

        <p class="loadingMore" @click="loadMore()" v-if="ps < total">加载更多</p>
        <p class="loadingMore" v-else>已加载全部</p>
    </div>
</template>

<script>
    import {Tab, Tabs, List} from 'vant';

    export default {
        name: "ServiceList",
        components: {
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [List.name]: List
        },
        data() {
            return {
                tabNameList: [ // tab标题
                    {text: '办事服务', type: '1'},
                    {text: '便民咨询', type: '2'},
                ],
                tabNameListIndex: 0,// 存放tab下标
                searchList: [],//存放搜索出来得列表值
                error: false,// 控制访问接口异常情况下，可以再次重新访问接口
                value: '', //输入框里的值
                active: 0, // 控制tab选择
                ps: 0, // 每页展示的个数
                total: '',
                ListData: []
            }
        },
        methods: {
            /**
             * 获取搜索列表信息
             */
            search() {
                this.ListData = ['大口大口的急啊卡xsds大家看见艰苦艰苦恶气娥娥企鹅恶气企鹅',
                    '大口大口的急啊卡的金卡大家看见艰苦艰苦恶气娥娥企鹅恶气企鹅'
                ]
            },
            /**
             * 列表关键字变亮
             */
            test(value) {
                let val = this.value
                if (value) {
                    return value.replace(new RegExp(val, 'g'), '<i style="color: #f66">' + val + '</i>')
                }
            },
            /**
             * 获取列表信息
             * @param index 点击tab切换传来的下标
             */
            async getSearchListInfo(index) {
                if (this.tabNameListIndex !== index) {
                    this.page = 10
                }
                this.tabNameListIndex = index
                try {
                    const res = ''
                } catch (error) {
                    this.error = true
                    console.log(error);
                }
            },
            // 加载更多
            loadMore() {
                this.ps += 5
                this.sreach()
            },
        }
    }
</script>

<style scoped>
    .top {
        height: 1rem;
        background: #efeff4;
        display: flex;
        align-items: center;
    }

    .top input {
        width: 73%;
        height: 0.7rem;
        border-radius: 0.1rem;
        border: 1px solid #efeff4;
        margin: 0.15rem 0.2rem;
        padding-left: 0.2rem;
    }

    .top .sear {
        display: inline-block;
        width: 1.7rem;
        height: 0.7rem;
        background: #4d82f7;
        color: #fff;
        text-align: center;
        border-radius: 0.15rem;
        vertical-align: middle;
        line-height: 0.7rem;
    }

    .tab-p {
        width: 100%;
        border-bottom: 1px solid #e6e6e6;
        position: relative;
    }

    .tab-p p {
        width: 95%;
        padding: 0.3rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
    }

    .tab-p span {
        color: #d6d6d9;
        font-size: 0.5rem;
        position: absolute;
        top: 0.2rem;
        right: 0.2rem;
    }

    .loadingMore {
        text-align: center;
        color: #9a9a9a;
        margin-top: 0.2rem;
    }

</style>
<style>
    .search-list .van-tabs__line {
        background-color: #1989fa;
        width: 4.5rem !important;
    }

    .search-list .van-tab--active {
        color: #1989fa;
    }

    .search-list .van-tabs--line .van-tabs__wrap {
        border-bottom: 1px solid #e6e6e6;
    }
</style>
